export default "__VITE_ASSET__Det1losW__"